import AppointmentReminderSMSFormStep1 from './steps/AppointmentReminderSMSStep1';
import AppointmentReminderSMSFormStep2 from './steps/AppointmentReminderSMSStep2';

export const AppointmentReminderSMSFormSteps = [
  AppointmentReminderSMSFormStep1,
  AppointmentReminderSMSFormStep2,
];
